<template>
  <v-dialog v-model="dialog" :width="dialogWidth" :persistent="true" transition="fade-transition">
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text>
        <p v-if="name">{{name}}</p>
        <p>{{description}}</p>
        <p>{{$t('common.price')}}: {{purchaseValueToString(price)}} ({{$t('common.incl-tax')}})</p>
        <v-checkbox
            v-model="withdrawal"
            :label="$t('common.abandon-withdrawal-rights')"
            required
            :rules="validationRules.required"
        ></v-checkbox>
        <v-btn @click="open" :disabled="!withdrawal" class="primary">
          <v-icon left>mdi-open-in-new</v-icon>{{$tenant.tenant === 'bfv' ? $t('common.redeem-now') : $t('common.buy-now')}}
        </v-btn>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="error" text @click="close()">
          <v-icon left>mdi-close</v-icon>{{$t('common.cancel')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import purchaseProduct from "@/mixins/purchaseProduct";

export default {
  name: "CheckoutDialog",
  mixins: [purchaseProduct],
  components: {},
  props: {
    title: {
      type: String,
      default: 'Checkout'
    },
    name: {
      type: String,
      required: false
    },
    url: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    price: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true
    }
  },
  data: function() {
    return {
      dialog: false,
      withdrawal: false,
      validationRules: {
        required: [v => !!v || this.$t('common.mandatory-field')]
      },
    };
  },
  watch: {
    visible: function(val) {
      this.dialog = val;
    },
    dialog: function(val) {
      if (val === false) {
        this.closeAction();
      }
    }
  },
  computed: {
    dialogWidth: function() {
      if (this.$vuetify.breakpoint.smAndUp) {
        return "450";
      }
      return "90%";
    },
  },
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    open() {
      if(this.withdrawal) {
        let url = this.url;
        if (this.$common.isRunningInStandalone()) {
          console.log("Opening url " + url + " in popup window");
          this.$common.openPopupWindow(url);
        } else {
          console.log("Replacing window url with " + url + "");
          this.$common.replaceLocation(url);
        }
      }
    },
    close() {
      this.$emit("input", null);
      this.dialog = false;
    }
  }
};
</script>
<style scoped>
</style>
